import React, { useEffect, useState } from 'react';
import { Box, Button, Link, Paper, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const STORAGE_KEY = 'rideSaathiCookieConsent';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!localStorage.getItem(STORAGE_KEY));
  }, []);

  const saveChoice = (choice: 'accepted' | 'essential') => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        left: { xs: 12, md: 24 },
        right: { xs: 12, md: 'auto' },
        bottom: { xs: 12, md: 24 },
        zIndex: 1400,
        maxWidth: 520,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 2,
          borderRadius: 1.5,
          border: '1px solid rgba(7,24,45,0.1)',
          boxShadow: '0 24px 70px rgba(7,24,45,0.18)',
        }}
      >
        <Stack spacing={1.25}>
          <Typography variant="subtitle2" fontWeight={900}>Cookie preferences</Typography>
          <Typography variant="body2" color="text.secondary" lineHeight={1.65}>
            We use essential cookies for login and security, and optional analytics cookies to improve RideSaathi.
            Read our{' '}
            <Link component={RouterLink} to="/privacy" underline="hover">Privacy Policy</Link>
            {' '}and{' '}
            <Link component={RouterLink} to="/terms" underline="hover">Terms</Link>.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            <Button variant="contained" color="secondary" onClick={() => saveChoice('accepted')}>
              Accept cookies
            </Button>
            <Button variant="outlined" onClick={() => saveChoice('essential')}>
              Essential only
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

export default CookieConsent;
